module.exports = __webpack_public_path__ + "static/media/SatyamPandey.0b411840.png";